import { render, staticRenderFns } from "./combofund.vue?vue&type=template&id=2e8b72f9&scoped=true"
import script from "./combofund.vue?vue&type=script&lang=js"
export * from "./combofund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8b72f9",
  null
  
)

export default component.exports